import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const pannes = [
  "Volet bloqué",
  "Ne remonte / descend plus",
  "Moteur en panne",
  "Sangle ou cordon cassé",
  "Lames tordues",
  "Télécommande HS",
  "Volet bruyant",
];

export default function Pannes() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold mb-6">
              Les <strong className="text-brand-blue">pannes</strong> les plus courantes
            </h2>
            <ul className="space-y-3 mb-8">
              {pannes.map((p) => (
                <li key={p} className="flex items-center gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-brand-cyan/10 shrink-0">
                    <i className="ri-check-line text-brand-cyan text-sm"></i>
                  </span>
                  <span className="text-brand-blue text-base font-medium">{p}</span>
                </li>
              ))}
            </ul>

            <div className="bg-white rounded-xl border border-brand-border p-6 md:p-8">
              <h3 className="text-brand-blue text-lg font-bold mb-2">Diagnostic gratuit</h3>
              <p className="text-brand-text text-sm leading-relaxed mb-5">
                Notre technicien se déplace chez vous, identifie le problème et vous établit un devis clair — sans engagement.
              </p>
              <a
                href="tel:0374473240"
                className="flex items-center gap-2 bg-brand-cyan text-white px-6 py-3 rounded-full font-semibold text-sm hover:bg-brand-cyan/90 transition-all duration-200 btn-hover-effect w-full sm:w-auto text-center overflow-hidden justify-center"
              >
                <span className="btn-icon-wrap"><i className="ri-phone-line text-base"></i></span>
                Appeler le 03 74 47 32 40
              </a>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="relative rounded-xl overflow-hidden border border-brand-border">
              <ImagePlaceholder
                src="https://readdy.ai/api/search-image?query=White%20roller%20shutter%20showing%20multiple%20signs%20of%20damage%20including%20broken%20slats%20a%20frayed%20strap%20and%20a%20faulty%20motor%20mechanism%20on%20a%20modern%20French%20house%20window%20in%20a%20residential%20neighborhood%20near%20Strasbourg%20clean%20daylight%20professional%20repair%20photography%20warm%20neutral%20tones&width=700&height=520&seq=home-pannes&orientation=landscape"
                alt="Volet roulant endommagé avec lames cassées et sangle usée en attente de réparation à Strasbourg"
                className="w-full h-[400px] md:h-[560px]"
                loading="lazy"
                width={700}
                height={520}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}